import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    className: PropTypes.string
};

const defaultProps = {
    className: ''
};

function TagHelp(props) {
    return (
        <div className={props.className}>
            <h2><span className="fa fa-question-circle-o" aria-hidden={true}/> Help</h2>
            <hr/>
            <div className="font-size-14px">
                <div className="margin-bottom-md">
                    Integration Tags are used in LTI tool configurations to limit the scope of selectable activities. Providing the specified custom parameter in an LTI launch will limit the available activities to:
                    <ul className="listBulletIndent">
                        <li>Activities using this tag.</li>
                        <li>All activities in a project using this tag.</li>
                    </ul>
                </div>
                <code className="codeBlock margin-bottom-md">custom_tag=yourTagName</code>
                <p>
                    Note: Integration Tags are case sensitive.
                </p>
            </div>
        </div>
    );
}

TagHelp.propTypes = propTypes;
TagHelp.defaultProps = defaultProps;

export default TagHelp;